export default __webpack_public_path__ + "static/media/Balthus's Wolf Crossbow.52c59bdc.jpg";